import { graphqlRequest } from "../graphqlClient";
import type {
  AllTransactionViewConnection,
  AllTransactionViewFilterInput,
} from "../models/allTransactionView";
import type { AllTransactionViewSortInput } from "./allTransactionGraphqlService";

interface ScenarioAdjustableTransactionViewListResponse {
  scenarios: {
    scenarioAdjustableTransactionViewList: AllTransactionViewConnection;
  };
}

/**
 * Transactions that can still be targeted by an "Adjust Specific Transaction"
 * adjustment in the given scenario. Transactions already linked to a
 * transaction_adj adjustment on the same ledger side are excluded server-side, so
 * they never appear on any page. Pass `excludeAdjustmentId` when editing an
 * existing adjustment to keep its own transaction selectable.
 */
export async function getScenarioAdjustableTransactionsGraphql(
  scenarioId: number,
  excludeAdjustmentId?: number,
  filter?: AllTransactionViewFilterInput,
  first?: number,
  after?: string,
  sort?: AllTransactionViewSortInput[],
): Promise<AllTransactionViewConnection> {
  const query = `
    query ScenarioAdjustableTransactionViewList($scenarioId: Int!, $excludeAdjustmentId: Int, $filter: AllTransactionViewFilterInput, $first: Int, $after: String, $sort: [AllTransactionViewSortSortByInput!]) {
      scenarios {
        scenarioAdjustableTransactionViewList(scenarioId: $scenarioId, excludeAdjustmentId: $excludeAdjustmentId, filter: $filter, first: $first, after: $after, sort: $sort) {
          edges {
            cursor
            node {
              id
              source
              externalId
              reference
              accountCode
              accountName
              description
              transactionType
              amount
              outstanding
              transactionDate
              dueDate
              anticipatedPaymentDate
              category
              status
              dataSourceId
              dataSourceName
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
      }
    }
  `;
  const data =
    await graphqlRequest<ScenarioAdjustableTransactionViewListResponse>(query, {
      scenarioId,
      excludeAdjustmentId,
      filter,
      first,
      after,
      sort,
    });
  return data.scenarios.scenarioAdjustableTransactionViewList;
}
